import { render, staticRenderFns } from "./SelectCarrier.vue?vue&type=template&id=684ad657&"
import script from "./SelectCarrier.vue?vue&type=script&lang=js&"
export * from "./SelectCarrier.vue?vue&type=script&lang=js&"
import style0 from "./SelectCarrier.vue?vue&type=style&index=0&id=684ad657&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports